import React, { useState } from "react";

const YojnaTrackerContext = React.createContext({
  isOpenModal: false,
  updateOpenModal: () => {},
  isAddMode: true,
  updateAddMode: () => {},
  editData: {},
  updateEditData: () => {},
});

export const YojnaTrackerContextProvider = ({ children }) => {
  const [isOpenModalState, setIsOpenModalState] = useState(false);
  const [isAddModeState, setIsAddModeState] = useState(true);
  const [editDataState, setEditDataState] = useState({});

  const contextValue = {
    isOpenModal: isOpenModalState,
    updateOpenModal: setIsOpenModalState,
    isAddMode: isAddModeState,
    updateAddMode: setIsAddModeState,
    editData: editDataState,
    updateEditData: setEditDataState,
  };

  return (
    <YojnaTrackerContext.Provider value={contextValue}>
      {children}
    </YojnaTrackerContext.Provider>
  );
};

export default YojnaTrackerContext;
